"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseCommand = exports.CommandType = void 0;
const zod_1 = require("zod");
var CommandType;
(function (CommandType) {
    CommandType["createDocumentCommand"] = "createDocumentCommand";
    // Base document
    CommandType["setDocumentDescriptionCommand"] = "setDocumentDescriptionCommand";
    CommandType["setDocumentNameCommand"] = "setDocumentNameCommand";
    CommandType["clearDocumentCommand"] = "clearDocumentCommand";
    // Elements
    CommandType["addElementCommand"] = "addElementCommand";
    CommandType["removeElementCommand"] = "removeElementCommand";
    CommandType["connectPinsCommand"] = "connectPinsCommand";
    CommandType["disconnectPinsCommand"] = "disconnectPinsCommand";
    CommandType["setElementPropertyCommand"] = "setElementPropertyCommand";
    // Pcb nodes
    CommandType["addPcbNodesCommand"] = "addPcbNodesCommand";
    CommandType["updatePcbNodesCommand"] = "updatePcbNodesCommand";
    CommandType["removePcbNodesCommand"] = "removePcbNodesCommand";
    // Pcb global rule sets
    CommandType["addPcbRuleSetsCommand"] = "addPcbRuleSetsCommand";
    CommandType["updatePcbRuleSetsCommand"] = "updatePcbRuleSetsCommand";
    CommandType["removePcbRuleSetsCommand"] = "removePcbRuleSetsCommand";
    // TODO: Remove enriched command
    CommandType["enrichedAddPcbNodesCommand"] = "enrichedAddPcbNodesCommand";
    CommandType["enrichedUpdatePcbNodesCommand"] = "enrichedUpdatePcbNodesCommand";
})(CommandType || (exports.CommandType = CommandType = {}));
// TODO: Change to use z.enum() when all commands are migrated to zod
exports.BaseCommand = zod_1.z.object({
    type: zod_1.z.nativeEnum(CommandType),
});
//# sourceMappingURL=common.js.map